export enum ENUM__workspace_entity_collection {
  COLLECTION_UPLOADS = 'collection_uploads',
  COLLECTION_GENERATED = 'collection_generated',

  //to add cell no permissions needed
  COLLECTION_VIEWED_ON_SEARCH = 'collection_viewed_on_search',
  //to add/delete cell need permission collection_update
  COLLECTION_FAVORITES = 'collection_favorites',

  COLLECTION_CUSTOM = 'collection_custom',
}

export namespace ENUM_UTILS__workspace_entity_collection {
  export function get_non_custom_collections() {
    let out = Object.values(ENUM__workspace_entity_collection);

    out = out.filter(item => item != ENUM__workspace_entity_collection.COLLECTION_CUSTOM);

    return out;
  }
}
